import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import fr from './translations/fr.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      fr: {
        translation: fr
      }
    },
    lng: 'fr', // default language
    fallbackLng: 'en', // use 'en' if detected lng is not available
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
